export class EmployeeCadreHistories {
  ID: number;
  EmpCode: number;
  CadreId: number;
  CadreName: string;
  StartDate: Date;
  EndDate: Date;
  DivisionId: number;
CreatedBy: string;
CreatedDate: Date;
ModifiedBy: string;
  ModifiedDate: Date;
  IsActive: boolean;
  //to display error message for duplicate records in history tab
  hasDuplicateNameError?: boolean;
  duplicateNameMessage?: string;
}
